/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Pourchase_Issue_TitleInputs */

const en_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Issue`)
};

const ar_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشكلة في الشراء`)
};

const de_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaufproblem`)
};

const es_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de compra`)
};

const fr_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problème lors de l'achat`)
};

const it_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema con l'acquisto`)
};

const ja_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入に関する問題`)
};

const ko_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 이슈`)
};

const pt_br_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema na compra`)
};

const ru_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблема с покупкой`)
};

const th_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัญหาการซื้อ`)
};

const tr_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın Alma Sorunu`)
};

const zh_cn_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买失败`)
};

const zh_tw_dialog_pourchase_issue_title = /** @type {(inputs: Dialog_Pourchase_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購買失敗`)
};

/**
* | output |
* | --- |
* | "Purchase Issue" |
*
* @param {Dialog_Pourchase_Issue_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_pourchase_issue_title = /** @type {((inputs?: Dialog_Pourchase_Issue_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Pourchase_Issue_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_pourchase_issue_title(inputs)
	if (locale === "ar") return ar_dialog_pourchase_issue_title(inputs)
	if (locale === "de") return de_dialog_pourchase_issue_title(inputs)
	if (locale === "es") return es_dialog_pourchase_issue_title(inputs)
	if (locale === "fr") return fr_dialog_pourchase_issue_title(inputs)
	if (locale === "it") return it_dialog_pourchase_issue_title(inputs)
	if (locale === "ja") return ja_dialog_pourchase_issue_title(inputs)
	if (locale === "ko") return ko_dialog_pourchase_issue_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_pourchase_issue_title(inputs)
	if (locale === "ru") return ru_dialog_pourchase_issue_title(inputs)
	if (locale === "th") return th_dialog_pourchase_issue_title(inputs)
	if (locale === "tr") return tr_dialog_pourchase_issue_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_pourchase_issue_title(inputs)
	return zh_tw_dialog_pourchase_issue_title(inputs)
});